
import React, { useState } from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const Logo: React.FC<LogoProps> = ({ className = "", size = 'md' }) => {
  const [imgSrc, setImgSrc] = useState('/logo.png');
  const [error, setError] = useState(false);

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
    xl: 'w-24 h-24',
  };

  const handleError = () => {
    setError(true);
  };

  // If there's an error loading the PNG, we use a high-fidelity SVG version
  if (error) {
    return (
      <div 
        className={`bg-gradient-to-br from-[#3b82f6] to-[#a855f7] flex items-center justify-center shadow-xl transition-all duration-500 ${sizeClasses[size]} ${className}`}
        style={{ borderRadius: '28%' }}
      >
        <svg viewBox="0 0 100 100" className="w-[65%] h-[65%]" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Main body of the wallet */}
          <path 
            d="M18 44H82V64C82 69.5228 77.5228 74 72 74H28C22.4772 74 18 69.5228 18 64V44Z" 
            fill="white" 
          />
          {/* Top flap of the wallet */}
          <path 
            d="M18 38C18 32.4772 22.4772 28 28 28H72C77.5228 28 82 32.4772 82 38V42H18V38Z" 
            fill="white" 
          />
          {/* The snap button indentation */}
          <circle cx="68" cy="59" r="6" fill="#4A6CF7" fillOpacity="0.25" />
        </svg>
      </div>
    );
  }

  return (
    <div className={`${sizeClasses[size]} flex items-center justify-center overflow-hidden ${className}`}>
      <img 
        src={imgSrc} 
        alt="Equilibra Logo" 
        className="w-full h-full object-cover"
        style={{ borderRadius: '28%' }}
        onError={handleError}
        referrerPolicy="no-referrer"
      />
    </div>
  );
};

export default Logo;
